<template>
    <div class="item">
        <div class="item-title">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                {{info.name}}
            </el-checkbox>
        </div>
        <el-checkbox-group class="select" v-model="value" @change="handleCheckedChange">
            <el-checkbox
                    v-for="item of info.permissions"
                    :key="item.id"
                    :label="item.id">
                {{item.name}}
            </el-checkbox>
        </el-checkbox-group>
    </div>
</template>
<script>
    export default {
        props: {
            info: Object
        },
        data() {
            let value = [];
            this.info.permissions.forEach(item => {
                if (item.checked) {
                    value.push(item.id)
                }
            });

            return {
                isIndeterminate: true,
                checkAll: false,
                value: value,
            }
        },
        created(){
            this.handleCheckedChange(this.value)
        },
        methods: {
            handleCheckAllChange(val) {
                this.value = val ? this.info.permissions.map(v => v.id) : [];
                this.isIndeterminate = false;
            },
            handleCheckedChange(value) {
                let l = value.length;
                this.checkAll = l === this.info.permissions.length;
                this.isIndeterminate = l > 0 && l < this.info.permissions.length;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .item {
        margin-top: 20px;
        background-color: #fff;
        border: 1px solid $border-color;
        &-title {
            padding: 10px;
            border-bottom: 1px solid $border-color;
        }
    }

    .select {
        display: flex;
        flex-wrap: wrap;
        padding: 0 10px 10px 30px;
        :global(.el-checkbox) {
            display: flex;
            position: relative;
            width: 20%;
            margin-top: 10px;
            margin-right: 0;
        }
        :global(.el-checkbox__input){
            margin-top: 2px;
        }
        :global(.el-checkbox__label){
            white-space: normal;
            padding-right: 10px;
        }
    }
</style>